import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { Link } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { getPageTotalCount } from '../../../utils/utils';
import { DataTable, TablePagination, Breadcrumb } from '../../../components/common';
import RouteNames from '../../App/RouteNames';
import packageSort from '../../../constantsApp/bundleManager/packageSort';
import { makeGetListPackages, makeErrorMessage } from '../selectors';
import { searchPackages, setParamsPackages } from '../actions';
import { PackageSearchForm } from '../../../components/PricingHub';
import {
  checkPermissionSearchPackage,
  checkPermissionGetPackage,
  checkPermissionCreatePackage,
  checkPermissionModifyPackage,
} from '../CheckPermission';
import { makeGetPermissionsBundleManagement } from '../../App/selectors';

class PackageItem extends Component {
  state = {
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (state && props.listPackages) {
      return {
        totalCount: getPageTotalCount({ ...state, items: props.listPackages }),
      };
    }
    return {};
  }

  componentDidMount() {
    const { location } = this.props;
    if (location && location.state && location.state.filter) {
      this.setState({ filter: location.state.filter }, () => {
        this.doSearchPackages();
      });
    } else {
      this.doSearchPackages();
    }
  }

  onClickRow = e => {
    e.preventDefault();
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doSearchPackages());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchPackages());
  };

  onSubmitSearch = filteredData => {
    this.setState({ filter: filteredData, page: 0 }, () => this.doSearchPackages());
  };

  doSearchPackages = () => {
    const { page, size, sorted, filter } = this.state;
    const { searchPackages } = this.props;
    const sort =
      sorted && sorted.sortCol && sorted.sortDir && packageSort[sorted.sortCol]
        ? packageSort[sorted.sortCol][sorted.sortDir]
        : null;
    this.setState({ isSearching: true });
    const params = {
      page: page + 1,
      size,
      filter,
    };
    if (sort) {
      params.sort = sort;
    }
    searchPackages(params, () => {
      this.setState({ isSearching: false, filter, sort });
    });
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => this.doSearchPackages());
  };

  render() {
    const { listPackages, permissionsBundleManagement, t } = this.props;
    const { sorted, isSearching, page, size, totalCount, filter } = this.state;
    let modeSearchPackage = 0;
    let modeGetPackage = 0;
    let modeCreatePackage = 0;
    let modeModifyPackage = 0;
    const tableColumns = [
      {
        name: 'id',
        label: 'common:label.id',
        render: (colName, item) => (
          <Link
            className="text-success"
            to={{ pathname: RouteNames.prettifyPath(RouteNames.packageItemEdit.path, item.id), state: { filter } }}
          >
            {item.id}
          </Link>
        ),
      },
      {
        name: 'name',
        label: 'common:label.name',
        sortName: 'name',
        sortable: true,
        style: { minWidth: '120px' },
      },
      {
        name: 'description',
        label: 'common:label.description',
      },
      {
        name: 'salesChannel',
        label: 'common:label.salesChannel',
        sortable: true,
        style: { minWidth: '130px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:salesChannel')().find(val => val.value === item.salesChannel) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'marketSegment',
        label: 'common:label.marketSegment',
        sortable: true,
        style: { minWidth: '130px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:marketSegment')().find(val => val.value === item.marketSegment) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'accountType',
        label: 'common:label.accountType',
        sortable: true,
        style: { minWidth: '120px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:accountType')().find(val => val.value === item.accountType) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'accountSubType',
        label: 'common:label.accountSubType',
        sortable: true,
        style: { minWidth: '140px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:accountSubType')().find(val => val.value === item.accountSubType) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'country',
        label: 'common:label.country',
        sortable: true,
        style: { minWidth: '90px' },
      },
      {
        name: 'currency',
        label: 'common:label.currency',
        sortable: true,
        style: { minWidth: '90px' },
      },
      {
        name: 'status',
        label: 'common:label.status',
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:statusPricing')().find(val => val.value === item.status) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'startDate',
        label: 'common:label.startDate',
        sortable: true,
        style: { minWidth: '120px' },
      },
      {
        name: 'action',
        label: 'common:label.action',
        isRenderT: true,
        render: (colName, item, t) => (
          <Link
            className="btn btn-outline-success btn-sm"
            to={{ pathname: RouteNames.prettifyPath(RouteNames.packageItemEdit.path, item.id), state: { filter } }}
          >
            {t('label.view')}
          </Link>
        ),
      },
    ];

    const newTableColumns = cloneDeep(tableColumns);

    if (permissionsBundleManagement && permissionsBundleManagement.bundleModulePermissions) {
      const listPermissionBundle = permissionsBundleManagement.bundleModulePermissions;
      modeSearchPackage = checkPermissionSearchPackage({ listPermission: listPermissionBundle });
      modeGetPackage = checkPermissionGetPackage({ listPermission: listPermissionBundle });
      modeCreatePackage = checkPermissionCreatePackage({ listPermission: listPermissionBundle });
      modeModifyPackage = checkPermissionModifyPackage({ listPermission: listPermissionBundle });
    }
    if (modeSearchPackage === 0 || modeGetPackage === 0) return '';
    if (modeModifyPackage === 0) {
      newTableColumns[0] = {
        name: 'id',
        label: 'Id',
      };
      newTableColumns.splice(newTableColumns.length - 1, 1);
    }

    const tableConfig = {
      columns: newTableColumns,
      sorted: { ...sorted },
      data: listPackages,
      onSort: this.onSortColumn,
      onClickRow: this.onClickRow,
      isLoading: isSearching,
    };
    return (
      <div>
        <div className="page-title">
          <div className="row">
            <div className="col-sm-6">
              <Link
                to={
                  modeCreatePackage !== 2
                    ? RouteNames.bundleItem.path
                    : { pathname: RouteNames.packageItemAdd.path, state: { filter } }
                }
                className="button x-small"
              >
                {modeCreatePackage !== 2 ? t('label.back') : t('label.createNewPackage')}
              </Link>
            </div>

            <div className="col-sm-6">
              <Breadcrumb
                items={[
                  { name: t('navbar:pricingHub.subMain.bundleManagement'), url: RouteNames.bundleItem.path },
                  { name: t('bundlePage:sidebar.package'), url: RouteNames.packageItem.path },
                ]}
              />
            </div>
          </div>
        </div>

        <br />
        <div className="col-md-12 mb-30">
          <div className="card card-statistics h-100">
            <div className="card-body">
              <div className="repeater-file">
                <div data-repeater-list="group-a">
                  <PackageSearchForm onSubmit={this.onSubmitSearch} isSubmitting={isSearching} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-12 mb-30">
          <div className="card card-statistics h-100">
            <div className="card-body">
              <DataTable {...tableConfig} isSubmitting={isSearching} />
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
      </div>
    );
  }
}

PackageItem.propTypes = {
  permissionsBundleManagement: PropTypes.objectOf(PropTypes.any),
  searchPackages: PropTypes.func.isRequired,
  listPackages: PropTypes.arrayOf(PropTypes.any),
};

PackageItem.defaultProps = {
  permissionsBundleManagement: {},
  listPackages: [],
};

const mapStateToProps = createStructuredSelector({
  listPackages: makeGetListPackages() || [],
  errorMessage: makeErrorMessage() || '',
  permissionsBundleManagement: makeGetPermissionsBundleManagement() || {},
});

const newPackageItem = connect(mapStateToProps, { searchPackages, setParamsPackages })(PackageItem);

export default withTranslation(['common', 'navbar', 'bundlePage'])(newPackageItem);
